import React from 'react';
import { Link } from "react-scroll";
import Button from 'react-bootstrap/Button';

// import { Container } from './styles';

function Pgrss({vector1, newAttendance, pgrs1, arrowUp, arrowDown}) {
    return (
        <div id="pgrss">
            <div className="bodySolucoes sumir" style={{backgroundColor: 'var(--main-white-color)', width: "100%", marginBottom: 50, overflowY: "hidden", overflowX: 'hidden', position: 'relative'}}>
                <img
                src={vector1}
                alt="Vector"
                className='vector'
                />
                <div
                style={{
                    display: "flex",
                    justifyContent: 'center',
                    alignItems: 'center',
                    lineHeight: 1,
                    height: 120,
                }}>
                    <p 
                    style={{
                        color: "var(--main-bg-color)", 
                        fontSize: 34, 
                        fontWeight: 700,
                        margin: 20
                    }}>
                        <span style={{fontSize: 20, color: 'var(--main-secondy)'}}>CONSULTORIA DE </span><br></br> 
                        PGRS/PGRSS <br></br>
                    </p>
                </div>
                <div className="row" style={{width: "100%"}}>
                    <div className='col-12 col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6'
                        style={{
                            display: "flex",
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                            flexDirection: 'column'
                        }}>
                        <div className="row" style={{
                            display: "flex",
                            alignItems: 'center',
                            padding: 40,
                            paddingLeft: 120
                        }}>
                            <p 
                            className='titleText'>
                                Saiba agora todos os detalhes da nossa consultoria.
                            </p>
                            <p 
                            className='subTitleText' style={{paddingRight: 30}}>
                                O Plano de Gerenciamento de Resíduos Sólidos e Resíduos de Serviços de Saúde são obrigatórios para qualquer empresa
                                obter uma licença ambiental.
                                <br></br>
                                Confira os principais motivos para solicitar um PGRS/PGRSS:
                                <br></br>
                                1. Respaldo Jurídico;<br></br>
                                2. Conformidade Legal;<br></br>
                                3. Tranquilidade Sanitária;<br></br>
                                <br></br>
                                Não corra o risco de ser autuado pela falta de um PGRS/PGRSS bem elaborado. 
                            </p>
                            <div style={{width: '100%', display: "flex", alignItems: 'center', justifyContent: 'center', marginTop: 10}}>
                                <Button style={{
                                    boxShadow: "0px 15.3171px 15.3171px rgba(0, 0, 0, 0.25)",
                                    backgroundColor: "var(--main-bg-color)",
                                    border: 0,
                                }} 
                                variant="secondary"
                                onClick={() => newAttendance('Olá grupo Urbam, solicito orçamento sobre o Consultoria PGRS/PGRSS')}
                                >
                                    ORÇAMENTO | PGRS/PGRSS
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6'
                    style={{
                        display: "flex",
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        marginTop: 20,
                        position: 'relative'
                    }}>
                        <img
                        src={pgrs1}
                        alt="Imagem consultoria pgrss"
                        style={{width: "90%", paddingRight: 70}}
                        />
                        <Link
                            activeClass="active"
                            to="quimico"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="buttonUpR"
                            containerId="conteiner"
                            >
                            <img
                                src={arrowUp}
                                alt="Seta pra cima"
                            />
                        </Link>
                        <Link
                            activeClass="active"
                            to="app"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="buttonDownR"
                            containerId="conteiner"
                            >
                            <img
                                src={arrowDown}
                                alt="Seta pra baixo"
                            />
                        </Link>
                    </div>
                </div>
            </div>
            <div className="bodySolucoes mostrar" style={{backgroundColor: 'var(--main-white-color)', width: "100%", margin: 0, overflowY: "hidden", overflowX: 'hidden', position: 'relative'}}>
                <div
                style={{
                    display: "flex",
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    lineHeight: 1,
                    height: 120,
                }}>
                    <p 
                    style={{
                        color: "var(--main-bg-color)", 
                        fontSize: 34, 
                        fontWeight: 700,
                        margin: 20,
                        marginLeft: 90
                    }}>
                        <span style={{fontSize: 20, color: 'var(--main-secondy)'}}>CONSULTORIA DE </span><br></br> 
                        PGRS/PGRSS <br></br>
                    </p>
                </div>
                <div className="row" style={{width: "100%"}}>
                    <div className='col-12 col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6'
                    style={{
                        display: "flex",
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'relative'
                    }}>
                        <Link
                            activeClass="active"
                            to="quimico"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="buttonUpL"
                            containerId="conteiner"
                            >
                            <img
                                src={arrowUp}
                                alt="Seta pra cima"
                            />
                        </Link>
                        <Link
                            activeClass="active"
                            to="app"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="buttonDownL"
                            containerId="conteiner"
                            >
                            <img
                                src={arrowDown}
                                alt="Seta pra baixo"
                            />
                        </Link>
                        <img
                        src={pgrs1}
                        alt="Imagem consultoria pgrss"
                        style={{width: "94%", paddingLeft: 68}}
                        />
                        
                    </div>
                    <div className='col-12 col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6'
                        style={{
                            display: "flex",
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                            flexDirection: 'column'
                        }}>
                        <div className="row" style={{
                            display: "flex",
                            alignItems: 'center',
                            padding: 40,
                            paddingLeft: 60
                        }}>
                            <p 
                            className='titleText'>
                                Saiba agora todos os detalhes da nossa consultoria.
                            </p>
                            <p 
                            className='subTitleText' style={{paddingRight: 30}}>
                                O Plano de Gerenciamento de Resíduos Sólidos e Resíduos de Serviços de Saúde são obrigatórios para qualquer empresa
                                obter uma licença ambiental.
                                <br></br><br></br>
                                Confira os principais motivos para solicitar um PGRS/PGRSS:
                                <br></br><br></br>
                                1. Respaldo Jurídico;<br></br>
                                2. Conformidade Legal;<br></br>
                                3. Tranquilidade Sanitária;<br></br>
                                <br></br><br></br>
                                Não corra o risco de ser autuado pela falta de um PGRS/PGRSS bem elaborado. 
                            </p>
                            <div style={{width: '100%', display: "flex", alignItems: 'center', justifyContent: 'center', marginTop: 30}}>
                                <Button style={{
                                    boxShadow: "0px 15.3171px 15.3171px rgba(0, 0, 0, 0.25)",
                                    backgroundColor: "var(--main-bg-color)",
                                    border: 0,
                                }} 
                                variant="secondary"
                                onClick={() => newAttendance('Olá grupo Urbam, solicito orçamento sobre o Consultoria PGRS/PGRSS')}
                                >
                                    ORÇAMENTO | PGRS/PGRSS
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Pgrss;